import React, { useEffect, useState } from 'react';
import { Container, ThisTicket, ThisCab, ThisChat } from './styles';
import IconSolicitante from '~/assets/icones/IconSolicitante.svg';
import IconUrgencia from '~/assets/icones/IconUrgencia.svg';
import IconRsp from '~/assets/icones/IconRsp.svg';
import IconCategoria from '~/assets/icones/IconCategoria.svg';
import IconAvatarChat from '~/assets/icones/IconAvatarChat.svg';
import IconImgChat from '~/assets/icones/IconImgChat.svg';
import IconAponta from '~/assets/icones/IconAponta.svg';
import IconApontaAtivo from '~/assets/icones/IconApontaAtivo.svg';
import IconClipe from '~/assets/icones/IconClipe.svg';
import IconDown from '~/assets/icones/IconDown.svg';
import IconDownAtivo from '~/assets/icones/IconDownAtivo.svg';
import { Materialize } from '~/styles/materializeGrid';


function CreateContent({ mountedData }) {
  const [clientes, setClientes] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [ordemServicoAtividades, setOrdemServicoAtividades] = useState([]);

  let chat = [
    { 
      nome: 'Daniela Martins', 
      data: '17/04/2023', 
      hora: '09:35', 
      acao: 'Ação Pública', 
      ativo: false,
      apontamentos: {
        inicio: '14h',
        fim: '18h',
        tempo: '4h'
      },
      mensagem:{
        texto: 'Bom dia! Pedimos a gentileza que encaminhe este erro conforme a orientação abaixo: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      },
      anexo: [
        {link: 'Anexo_Teste.png'},
        {link: 'Anexo_Teste.png'},
        {link: 'Anexo_Teste.png'},
      ]
    },
    { 
      nome: 'Renan R. Santos', 
      data: '17/04/2023', 
      hora: '09:35', 
      acao: 'Ação Pública', 
      ativo: true,
      apontamentos: {
        inicio: '14h',
        fim: '18h',
        tempo: '4h'
      },
      mensagem:{
        texto: 'Bom dia! Pedimos a gentileza que encaminhe este erro conforme a orientação abaixo:',
      },
      anexo: [
        {link: 'Anexo_Teste.png'},
      ]
    },
    { 
      nome: 'Daniela Martins', 
      data: '17/04/2023', 
      hora: '09:35', 
      acao: 'Ação Pública', 
      ativo: false,
      apontamentos: {
        inicio: '14h',
        fim: '18h',
        tempo: '4h'
      },
      mensagem:{
        texto: 'Bom dia! Pedimos a gentileza que encaminhe este erro conforme a orientação abaixo:',
      },
      anexo: [

      ]
    }
  ];

  useEffect(() => {
    let lista = [];
    let listaHor = [];
    let count = 1;
    for (let itemAtv of mountedData?.atividades) {
      lista.push(itemAtv);

      for (const itemAtivo of itemAtv?.horarios) {
        listaHor.push({
          id: count,
          titulo: 'º Horário',
          horaInicial: itemAtivo?.horaInicial,
          horaFinal: itemAtivo?.horaFinal,
          idProjetoAtividade: itemAtv?.idProjetoAtividade,
        });

        count++;
      }
    }
    setOrdemServicoAtividades(lista);

    setHorarios(listaHor);

    setClientes([mountedData?.cliente]);
    setProjetos([mountedData?.projeto]);
  }, [mountedData]);

  return (
    <Container defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row">
          <div className="row no-margin list-atv">
            <div className="item col s12 m12 l12">
              {mountedData?.atividades?.map((thisData, a) => (
                <ThisTicket>
                  <ThisCab className={'card-item'} index={a} ativo={true}>
                    <div className="card">
                      <div className="top">
                        <div className="content-top">
                          <div className="card-cod">
                            <p className="cod">#2555</p>
                          </div>
                          <div className="card-titulo">
                            <p className="titulo">Pedido de compra com SC - Erro</p>
                          </div>
                        </div>
                      </div>
                      <div className="infos">
                        <div className="card-info">
                          <div className="status"></div>
                          <p className="info">Status: Em Andamento</p>
                        </div>
                        <div className="card-info">
                          <img src={IconSolicitante} alt={"IconSolicitante"} />
                          <p className="info">Solicitante: Renan R. Santo</p>
                        </div>
                        <div className="card-info">
                          <img src={IconUrgencia} alt={"IconUrgencia"} />
                          <p className="info">Urgência: Baixa</p>
                        </div>
                        <div className="card-info">
                          <img src={IconRsp} alt={"IconRsp"} />
                          <p className="info">Responsável: Julia Xavier</p>
                        </div>
                        <div className="card-info">
                          <img src={IconCategoria} alt={"IconCategoria"} />
                          <p className="info">Categoria: Atualização</p>
                        </div>
                      </div>
                    </div>
                  </ThisCab>
                  <ThisChat>
                    {chat?.map((thiCha) => (
                      <div className="chat">
                        {thiCha?.ativo === false ?
                         (
                            <div className="msg">
                              <div className="avatar">
                                <img className="icon-img" src={IconImgChat} alt="Vazio" />
                              </div>
                              <div className="triangulo"></div>
                              <div className="balao">
                                <div className="cab">
                                  <div className="user">
                                    <div className="nome">{thiCha?.nome}</div>
                                    <p className="data">{thiCha?.data}</p>
                                    <p className="hora">{thiCha?.hora}</p>
                                  </div>
                                  <div className="aponta">
                                  <img className="icon-aponta" src={IconAponta} alt="Vazio" />
                                    <p className="inicio">Início: {thiCha?.apontamentos?.inicio}</p>
                                    <p className="fim">Fim: {thiCha?.apontamentos?.fim}</p>
                                    <p className="total">Tempo apontado: {thiCha?.apontamentos?.tempo}</p>
                                  </div>
                                </div>
                                <div className="mensagem">
                                  <div className="texto">
                                    <p>{thiCha?.mensagem?.texto}</p>
                                  </div>
                                  <div className="anexos">
                                    {thiCha?.anexo?.map((thiAnx) => (
                                      <div className="anexo">
                                        <div className="clipe">
                                          <img className="icon-clipe" src={IconClipe} />
                                        </div>
                                        <p className="texto-anexo">{thiAnx?.link}</p>
                                        <img className="icon-down" src={IconDown} />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="msg">
                              <div className="avatar">
                              <img className="IconAvatarChat" src={IconAvatarChat} alt="Vazio" />
                              </div>
                              <div className="triangulo triangulo-ativo"></div>
                              <div className="balao balao-ativo">
                              <div className="cab">
                                <div className="user">
                                  <div className="nome">{thiCha?.nome}</div>
                                  <p className="data">{thiCha?.data}</p>
                                  <p className="hora">{thiCha?.hora}</p>
                                </div>
                                <div className="aponta">
                                <img className="icon-aponta" src={IconApontaAtivo} alt="Vazio" />
                                  <p className="inicio">Início: {thiCha?.apontamentos?.inicio}</p>
                                  <p className="fim">Fim: {thiCha?.apontamentos?.fim}</p>
                                  <p className="total">Tempo apontado: {thiCha?.apontamentos?.tempo}</p>
                                </div>
                                </div>
                                <div className="mensagem">
                                  <div className="texto">
                                    <p>{thiCha?.mensagem?.texto}</p>
                                  </div>
                                  <div className="anexos">
                                    {thiCha?.anexo?.map((thiAnx) => (
                                      <div className="anexo anexo-ativo">
                                        <div className="clipe">
                                          <img className="icon-clipe" src={IconClipe} />
                                        </div>
                                        <p className="texto-anexo">{thiAnx?.link}</p>
                                        <img className="icon-down" src={IconDownAtivo} />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        }
                      </div>
                    ))}
                  </ThisChat>
                </ThisTicket>
              ))}
            </div>
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateContent;
